<template>
  <Row class="pl-3 pr-3 border-bottom" type="flex" justify="space-between" align="middle">
    <Breadcrumb>
      <BreadcrumbItem v-for="item in breadcrumb" :key="item.path">
        <strong>{{ item.name }}</strong>
      </BreadcrumbItem>
    </Breadcrumb>
    <Row>
      <Dropdown style="margin-left: 20px" placement="bottom-end" trigger="click">
        <Avatar style="background-color: #87d068" icon="ios-person" />
        <a href="javascript:void(0)">
          {{username}}
          <Icon type="ios-arrow-down"></Icon>
        </a>
        <DropdownMenu slot="list">
          <!-- <DropdownItem>信息</DropdownItem> -->
          <DropdownItem>
            <div @click="toUpdatePassWord()">修改密码</div>
          </DropdownItem>
          <DropdownItem>
            <div @click="loginOut()">退出登录</div>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </Row>
  </Row>
</template>
<script>
export default {
  name: "navbar",
  data: function () {
    return {
      breadcrumb: null,
      username: "",
    };
  },
  watch: {
    $route: function () {
      this.getBreadcrumb();
    },
  },
  created: function () {
    this.username = this.$store.state.name;
    this.getBreadcrumb();
  },
  methods: {
    getBreadcrumb: function () {
      let matched = this.$route.matched.filter((item) => item.name);
      this.breadcrumb = matched;
    },
    loginOut: function () {
      this.$store.dispatch("loginOut", null).then((rsp) => {
        this.$router.push({ path: "/login" });
      });
    },
    toUpdatePassWord() {
      this.$router.push({ path: "/basedata/updatepassword" });
    },
  },
};
</script>
